import { IconComponentProps } from '../IconTypes';

const SortUp = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.558 6.43315C11.8017 6.18901 12.1975 6.18901 12.4416 6.43315L16.192 10.1832C16.4361 10.427 16.4361 10.8227 16.192 11.0668C16.07 11.1889 15.9103 11.2499 15.7502 11.2499C15.59 11.2499 15.4299 11.1874 15.3084 11.0671L12.6252 8.38393V17.1249C12.6252 17.4704 12.3439 17.7499 12.0002 17.7499C11.6564 17.7499 11.3752 17.4687 11.3752 17.1249V8.38393L8.69159 11.0667C8.44784 11.3109 8.05214 11.3105 7.808 11.0667C7.56386 10.823 7.56386 10.4273 7.808 10.1832L11.558 6.43315Z"
      fill="currentColor"
    />
  </svg>
);

export default SortUp;
